import { useFormContext, useWatch, UseFormProps, UseFormReturn } from "react-hook-form";

import { useAppStore } from '../store/appStore';

import { cleanSsn } from '../lib/strFunctions/cleanSsid'

import { Box, Card, CardContent, LinearProgress, Typography } from "@mui/material";
import Grid from '@mui/material/Unstable_Grid2'

import { IPerson } from "../lib/interfaces/models";

import { TextInput } from "../components/TextInput";
import { EmailInput } from "../components/EmailInput";
import { SelectInput } from "../components/SelectInput";



interface IOSchool {
  title: string
  value: number
}


interface IStudentFormProps {
  oSchoolOptions: IOSchool[]
  oSchoolClassOptions: IOSchool[]
  oclass: number
  oschool: number
  oschoolclass?: boolean
  readonly?: boolean
}


//////////////////////////////////////////////////////////
export const StudentForm = (props: IStudentFormProps) => {
  const form: UseFormReturn<IPerson, UseFormProps> = useFormContext();

  const setGuardian1Checked = useAppStore(state => state.setGuardian1Checked)

  const studentSsnResult = cleanSsn(
    useWatch({
      control: form.control,
      name: 'ssid',
    }) || ""
  )
  // const { ageNow, ageThisYear, appendix, birthDay, birthdayNow, error, minor, ssn } = studentSsnResult
  const { error, minor } = studentSsnResult

  if (!error) {
    setGuardian1Checked(minor ? true : false)
    // console.log('StudentForm', studentSsnResult)
  }



  return (
    <Box sx={{ minWidth: 275, mt: 1 }}>
      <Card variant="outlined" sx={{ backgroundColor: '#EAF2F1', borderRadius: .6 }}>
        <CardContent>
          <Typography variant="h6" gutterBottom sx={{ ml: 3 }}>Nemandi</Typography>
          <Grid container spacing={1}>

            <Grid xs={12} sm={3.2} md={1.8} lg={1.5} xl={1.15}>
              <TextInput name="ssid" type="tel" label="Kennitala" placeholder="Sláið inn hér" readonly={props.readonly} />
            </Grid>
            <Grid xs={12} sm={8.7} md={4.8} lg={5} xl={5}>
              <TextInput name="name" label="Nafn nemanda" placeholder="Sláið inn hér" readonly={props.readonly} />
            </Grid>
            <Grid xs={12} sm={3.2} md={1.8} lg={1.5} xl={1.15}>
              <TextInput name="tel1" type="tel" label="GSM sími" placeholder="Símanr" readonly={props.readonly} />
            </Grid>

            <Grid xs={12} sm={3.2} md={1.8} lg={1.5} xl={1.15}>
              <TextInput name="tel2" type="tel" label="Sími 2" placeholder="Símanr" readonly={props.readonly} />
            </Grid>

            <Grid xs={12} sm={3.2} md={1.8} lg={1.5} xl={1.15}>
              <TextInput name="tel3" type="tel" label="Sími 3" placeholder="Símanr" readonly={props.readonly} />
            </Grid>
            <Grid xs={12} sm={12} md={4} lg={4} xl={4}>
              <EmailInput name="email1" type="email" label="Netfang" placeholder="Sláið inn hér" readonly={props.readonly} />
            </Grid>
            <Grid xs={12} sm={12} md={4} lg={4} xl={4}>
              <EmailInput name="email2" type="email" label="Netfang 2 (ef við á)" placeholder="Sláið inn hér" readonly={props.readonly} />
            </Grid>
            <Grid xs={12} sm={12} md={4} lg={4} xl={4}>
              <EmailInput name="email3" type="email" label="Netfang 3 (ef við á)" placeholder="Sláið inn hér" readonly={props.readonly} />
            </Grid>

            {props.oschool === 1 && <Grid xs={12} sm={12} md={4} lg={3} xl={3}>
              <SelectInput name="oschool" label="Skóli" options={props.oSchoolOptions} />
            </Grid>}

            {props.oclass === 1 &&
              <Grid xs={12} sm={3.2} md={1.8} lg={1.5} xl={1.15}>
                <SelectInput name="oschoolclass" label="Bekkur" options={props.oSchoolClassOptions} />
              </Grid>
            }

          </Grid>
        </CardContent>
      </Card>
    </Box>
  )
}
